import Vue from 'vue'
import Vuex from 'vuex'
import { info } from './api/user'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: false
  },
  mutations: {
    user (state, user) {
      state.user = user
    }
  },
  actions: {
    user ({ commit }) {
      return new Promise((resolve, reject) => {
        info().then(user => {
          commit('user', user)
          resolve(user)
        }).catch(error => {
          reject(error)
        })
      });
    }
  },
  getters: {
    isLogin (state) {
      return state.user
    }
  }
})

export default store